import React from 'react'
import styled from 'styled-components'
import AntTabs from 'antd/lib/tabs'
import { color } from '../styles'
import { text } from '../styles/mixins/text'
import { SPACING } from '../styles/mixins/constants'

const { TabPane } = AntTabs

export type TabType<K = string> = {
    title: string
    key: K
    Component: JSX.Element
    disabled?: boolean
}

type Props = {
    tabs: Array<TabType>
    activeKey: TabType['key'] | null
    className?: string
    onNavTab?: (nextKey: TabType['key']) => void
}

export const TabContainer = (props: Props): JSX.Element => {
    const { tabs, activeKey, className, onNavTab } = props

    return (
        <Container className={className}>
            <AntTabs activeKey={activeKey || undefined} onChange={(nextKey) => onNavTab?.(nextKey)}>
                {tabs.map(({ title, key, disabled, Component }) => (
                    <TabPane tab={title} key={key} disabled={Boolean(disabled)}>
                        {Component}
                    </TabPane>
                ))}
            </AntTabs>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex: 1 1 auto;
    min-height: 0;
    min-width: 0;

    .ant-tabs {
        display: flex;
        flex-flow: column nowrap;
        flex: 1 1 auto;
        min-height: 0;
        min-width: 0;
        ${text('paragraph', 'primary', 'text')}
    }
    .ant-tabs-tabpane {
        display: flex;
        flex-flow: column nowrap;
        flex: 1 1 auto;
        min-height: 0;
        min-width: 0;
    }
    .ant-tabs-tab,
    .ant-tabs-tab-btn {
        text-transform: uppercase;
        ${text('paragraph', 'secondary', 'text')}
        padding: ${SPACING[1]} ${SPACING[3]};
        &:hover {
            color: ${color.text.primary};
            opacity: 0.5;
        }
        &:active {
            opacity: 1;
            color: ${color.text.primary};
        }
    }

    .ant-tabs-tab-active .ant-tabs-tab-btn {
        ${text('paragraph', 'secondary', 'text', 'bold')}
        color: ${color.brand.primary};
    }

    .ant-tabs-ink-bar {
        background: ${color.brand.primary};
    }
    .ant-tabs-nav::before {
        border-bottom: 1px solid ${color.border.muted};
    }
    .ant-tabs-tab-disabled,
    .ant-tabs-tab-disabled.ant-tabs-tab-active > .ant-tabs-tab-btn {
        color: ${color.text.muted};
        cursor: not-allowed;
        user-select: none;
    }
    .ant-tabs-content-holder {
        display: flex;
        flex: 1 1 auto;
        min-height: 0px;
        min-width: 0px;
    }
`
